/* =============================================================================
   assets/rm-pixel-events.js
   Rustic & Main — Lead event bridge to GTM / Elevar

   Pushes a named dataLayer event for each lead type so GTM can route them
   to separate GA4, Google Ads, Meta, and Pinterest tags — mirroring the
   existing quiz_subscribe pattern.

   Events pushed:
     'Save My Ring'   → dataLayer event: save_my_ring
     'Giveaway Entry' → dataLayer event: giveaway_entry

   GTM setup (per event, same pattern as Quiz Subscribe):
     1. Trigger  : Custom Event, event name = save_my_ring (or giveaway_entry)
     2. Tags     : Duplicate GA4, Google Ads, Pinterest, Meta quiz tags
                   → swap trigger to the new one
                   → update conversion label / lead type as needed
   ============================================================================= */

(function () {
  'use strict';

  /**
   * Push a named lead event into the dataLayer.
   * leadType is converted to snake_case for the GTM event name.
   * e.g. 'Save My Ring' → save_my_ring | 'Giveaway Entry' → giveaway_entry
   *
   * @param {string} leadType  Human-readable lead type
   * @param {Object} [extra]   Optional extra properties
   */
  function lead(leadType, extra) {
    var eventName = leadType.toLowerCase().replace(/\s+/g, '_');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:      eventName,
      lead_type:  leadType,
      lead_extra: extra || {}
    });
  }

  window.rmTrack = { lead: lead };

})();
